import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { $Elements, Breakpoints, BrowserEvents, Classes } from './constants';

gsap.registerPlugin(ScrollTrigger);

;(function($) {

	const Selectors = {
		hero: '.hero-home',
		image: '.hero-home .parallax-image .image',
		wordmark: '.hero-home .hero-wordmark',
		wordmarkInner: '.hero-home .hero-wordmark > *',
		scrollLine: '.hero-home .hero-scroll',
	};

	const Scales = {
		intro: '--hero-intro-scale',
		scroll: '--hero-scroll-scale',
	};

	const WordmarkOcclusion = 0.8;
	let heroMedia = null;

	function getScroller() {

		const body = document.body;
		const isBodyScrollable = (body.scrollHeight > body.clientHeight + 1) && (getComputedStyle(body).overflowY !== 'visible');

		return isBodyScrollable ? body : window;
	}

	function prefersReducedMotion() {
		return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	}

	function revealHero() {

		gsap.timeline({ defaults: { ease: 'power4.out' }, onComplete: () => ScrollTrigger.refresh() })
			.fromTo(Selectors.image, { [Scales.intro]: 1.1, opacity: 0 }, { [Scales.intro]: 1, opacity: 1, duration: 2.5 }, 0)
			.to(Selectors.wordmarkInner, { y: 0, opacity: 1, duration: 1 }, 1)
			.to(Selectors.scrollLine, { scaleY: 1, duration: 0.8, ease: 'power2.inOut' }, 1.6);
	}

	function getWordmarkFadeEnd(hero) {

		const wordmark = hero.querySelector('.hero-wordmark');

		if(!wordmark) {
			return hero.offsetHeight;
		}

		const heroRect = hero.getBoundingClientRect();
		const wordmarkRect = wordmark.getBoundingClientRect();
		const distanceToWordmark = heroRect.bottom - wordmarkRect.bottom;

		return Math.max(distanceToWordmark + wordmarkRect.height * WordmarkOcclusion, 1);
	}

	function scrubHero(hero) {

		heroMedia = gsap.matchMedia();

		heroMedia.add(`(min-width: ${Breakpoints.Mobile}px)`, () => {

			const scroller = getScroller();

			gsap.fromTo(Selectors.image, { [Scales.scroll]: 1 }, {
				[Scales.scroll]: 1.1,
				ease: 'none',
				scrollTrigger: {
					scroller,
					start: 1,
					end: () => hero.offsetHeight,
					scrub: 0.8,
					invalidateOnRefresh: true,
				},
			});

			gsap.to(Selectors.wordmark, {
				opacity: 0,
				ease: 'none',
				scrollTrigger: {
					scroller,
					start: 1,
					end: () => getWordmarkFadeEnd(hero),
					scrub: 0.6,
					invalidateOnRefresh: true,
				},
			});
		});
	}

	$Elements.document.on(BrowserEvents.page.enter, () => {

		if(heroMedia) {
			heroMedia.revert();
			heroMedia = null;
		}

		const hero = document.querySelector(Selectors.hero);

		if(!hero || prefersReducedMotion()) {
			return;
		}

		if($Elements.body.hasClass(Classes.disclaimer)) {
			$Elements.document.one(BrowserEvents.disclaimer.accepted, revealHero);
		} else {
			revealHero();
		}

		scrubHero(hero);
	});

	$Elements.document.on(BrowserEvents.animation.refresh, () => ScrollTrigger.refresh());

}(jQuery));
